import {apiClient, FetcherSettings} from './apiClient';

export const VERIFICATION_METHODS = {
  email: 'email',
  phone: 'phone_number',
} as const;

export type VerificationMethod =
  (typeof VERIFICATION_METHODS)[keyof typeof VERIFICATION_METHODS];

export type GeneratePayload = {
  method: VerificationMethod;
  target: string;
  reservation: string;
};

export type VerifyPayload = {
  method: VerificationMethod;
  target: string;
  credential: string;
  reservation: string;
};

export type GenerateResponse = {
  id: string;
  method: VerificationMethod;
  target: string;
  credential_type: 'otp';
  status: 'pending' | 'verified' | 'failed';
};

export type VerificationSettings = {
  housing: string;
  require_phone_otp: boolean;
  require_email_otp: boolean;
};

class VerificationApi {
  private ENDPOINTS = {
    generate: () => 'api/v1/verification/generate/',
    verify: () => 'api/v1/verification/verify/',
    settings: (housingId: string) => `api/v1/verification/settings?housing=${housingId}`,
  } as const;

  async generate(payload: GeneratePayload, fetcherSettings?: FetcherSettings) {
    const response = await apiClient.post<GenerateResponse>(this.ENDPOINTS.generate(), {
      json: payload,
      ...fetcherSettings,
    });
    return response.body;
  }

  async verify(payload: VerifyPayload, fetcherSettings?: FetcherSettings) {
    const response = await apiClient.post<{verified: boolean}>(this.ENDPOINTS.verify(), {
      json: payload,
      ...fetcherSettings,
    });
    return response.body;
  }

  async getSettings(housingId: string, fetcherSettings?: FetcherSettings) {
    const response = await apiClient.get<VerificationSettings[]>(
      this.ENDPOINTS.settings(housingId),
      fetcherSettings,
    );
    return response.body;
  }
}

export {VerificationApi};
